export const intimatePhrases = [
  "Have you ever broken off plans with me to be with someone else?",
  "Who is in control of our relationship?",
  "Do you think I’m more or less honest than you are?",
  "Do you ever put me down to make yourself feel better?",
  "What’s a fundamental difference between us, and will we ever resolve it?",
  "Do you think I’ll ever do anything worth being remembered by society?",
  "Where are we, and what are we doing, in ten years? Have we honestly improved each other’s lives?",
  "Have you ever harassed someone online? Do you think they deserved it?",
  "If someone was interested in dating me, what thing about me would you tell them to change their minds?",
  "What have I ruined for you?",
  "What problem do I think I’m successfully hiding from everyone, but is it completely obvious?",
  "Do you see us as equals?",
  "What do you wish I’d just shut up about?",
  "Do I often seem like I’m being fake?",
  "Do you think I’m a good parent material?",
  "What thing do I love that you hate?",
  "What negative thing have I said about you that’s haunted you forever?",
  "What one change could I make that would vastly improve who I am as a person?",
  "What ethical boundaries are you happy to cross?",
  "Am I too picky? Too petty? Too selfish?",
  "Have you ever considered ending our relationship? Why?",
  "What’s the most amount of money you would lend to me?",
  "Do you ever think I need to cut back on drinking or drugs?",
  "What’s the most needlessly mean thing you’ve ever heard me say about someone else?",
  "Have I ever done anything you think should have gotten me shitcanned?",
  "Are there certain situations with me you avoid on purpose?",
  "What’s the most egregious lie you’ve ever told me?",
  "Do you think I’m too clingy or demand too much attention?",
  "What personal demon are you in denial of?",
  "Do you think I’m continuing to grow, or is this the best I’ll ever be as a person?",
  "What advice do I need but don’t want to hear?",
  "Do you think I’m capable of doing something you could never forgive me for?",
  "Are you sometimes embarrassed to be seen with me? Why?",
  "What do I never seem to understand about you?",
  "Do you think I have overachieved or underachieved?",
  "What will you never understand about me?",
  "Name one thing I do that disgusts you.",
  "How have I disappointed you?",
  "Have you ever hurt someone on purpose?",
  "What do you think I need to just let go of?",
  "Name a time you wished we weren’t friends.",
  "Who’s someone we know that you wish I was more like and why?",
  "Do you ever feel like I’m holding you back?",
  "If I was in a relationship with someone you hated, would you tell me?",
  "Is there anything about me that creeps you out?",
  "Would you hire me?",
  "Do you have any secrets you keep from me and me only?",
  "Is there an expiration date on our relationship?",
  "Have I often struck you as immature or unable to take care of myself?",
  "Do you think I sometimes take advantage of other people?",
  "What do I think I’m great at, but am terrible at?",
  "Have you ever been genuinely scared of me?",
  "What’s the most serious crime you’ve ever committed?",
  "What is (or would be) the worst thing about having me as a travel companion?",
  "What’s the worst thought you’ve ever had that you’ve never shared with anyone?",
  "Do you think I’m a bully?",
  "What’s the bitchiest thing you’ve ever said about me behind my back?",
  "Name a time you could have helped someone, but didn’t bother.",
  "What’s the most selfish thing you’ve ever done?",
  "What’s the stupidest thing you’ve ever heard me say?",
  "What’s an offensive opinion you will never let go of?",
  "Do you think you’re better than me?",
  "If you do something you know is wrong, but don’t get caught, do you keep doing it?",
  "What’s the longest period you could spend with me before never wanting to see me again?",
  "Have you ever stolen anything from me?",
  "What’s the weirdest thing about me?",
  "If I died tomorrow, what regrets would you have about our relationship?",
  "Have you ever knowingly let me embarrass myself, even if you could have stopped it?",
  "Do you sometimes lie about being busy if you don’t want to deal with me?",
  "Would you trust me alone with your kids for more than a couple of hours?",
  "Do you ever warn people about me before they meet me?",
  "Do you ever have to fake empathy?",
  "Have you ever ghosted someone you were close with?",
  "What’s the most annoying thing I do without realizing it?",
  "What am I the most ignorant about?",
  "Do you ever think I stir up drama because I enjoy it?",
  "What’s something you know would make you a better person, but you just don’t want to do it?",
  "Have you ever stabbed someone in the back or actively plotted against them?",
  "Is this the best I’ve looked since you’ve known me?",
  "What’s the worst thing you’ve ever done to an animal?",
  "How have I changed for the worse since we’ve met?",
  "What’s the most unreasonable thing you’ve ever completely lost your shit over?",
  "What’s the most terrible thing you’ve ever done for money?",
  "How have you dishonored your parents?",
  "In what ways have you used me?",
  "Have you ever had to apologize to someone for my behavior?",
  "Have you ever intentionally scammed someone or misled them for personal gain?",
  "If someone important to you said they’d stop seeing you unless you stopped seeing me, would you?",
  "Name a time you thought I was weak.",
  "When was the last time you were out of control?",
  "When have you let your pride get in the way of doing the right thing?",
  "Have you ever forced someone to do something against their will?",
  "Have you ever pretended to be someone else on the internet?",
  "Would your life be any worse if we had never met?",
  "Have you ever lied on a resume?",
  "What have you done while intoxicated that you wish you could take back?",
  "What’s the angriest you’ve ever been to me?",
  "If we lived across the country from each other, do you think we’d lose touch?",
  "List all the illicit drugs you’ve tried. What more would you like to try?",
  "How confident are you in your oral sex skills? How do you know?",
  "Give us a passionate example of your dirty talk.",
  "Would you ever knowingly enter into an open relationship? What rules are required to keep the peace?",
];
